/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Header from "../layout/Header";
import { Sidebar } from "react-feather";

const FtVideos = () => {
  return (
    <div>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid pb-0">
          {/* Page Header */}
          <div className="page-header">
            <div className="content-page-header">
              <h5>Video</h5>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-lg-6">
              <div className="card">
                <div className="card-body card-buttons">
                  <h4 className="header-title">
                    نظام تحليل الميزانيات العمومية
                  </h4>
                  <p className="sub-header">تحميل ملف 6111</p>
                  {/* 21:9 aspect ratio */}
                  <div className="ratio ratio-21x9">
                    <iframe
                      width="1280"
                      height="720"
                      src="https://www.youtube.com/embed/AvsSQKN7JvY"
                      title="نظام تحليل الميزانيات العمومية"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end col */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-body card-buttons">
                  <h4 className="header-title">
                    نظام تحليل الميزانيات العمومية
                  </h4>
                  <p className="sub-header">تحميل ملف 6111</p>
                  {/* 16:9 aspect ratio */}
                  <div className="ratio ratio-16x9">
                    <iframe
                      width="1280"
                      height="720"
                      src="https://www.youtube.com/embed/AvsSQKN7JvY"
                      title="نظام تحليل الميزانيات العمومية"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end col */}
          </div>
          {/* end row */}
          <div className="row">
            <div className="col-lg-6">
              <div className="card">
                <div className="card-body card-buttons">
                  <h4 className="header-title">
                    فحص كشوف الرواتب، صناديق التقاعد{" "}
                  </h4>
                  <p className="sub-header">Fintrack</p>
                  {/* 4:3 aspect ratio */}
                  <div className="ratio ratio-4x3">
                    <iframe
                      width="315"
                      height="560"
                      src="https://www.youtube.com/embed/moMNWwsIPJY"
                      title="Fintrack"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end col */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-body card-buttons">
                  <h4 className="header-title">فين تراك | Finatrack</h4>
                  <p className="sub-header">مصمم للمهنيين … ومتاح للجميع.</p>
                  {/* 1:1 aspect ratio */}
                  <div className="ratio ratio-1x1">
                    <iframe
                      width="315"
                      height="560"
                      src="https://www.youtube.com/embed/yDh9B5_ISrE"
                      title="fintrack"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* end col */}
          </div>
          {/* end row */}
        </div>
      </div>
    </div>
  );
};

export default FtVideos;
